<template>
    <client-page>
        <mypage-layout titleSpacingLg title="회원정보수정">
            <v-tabs-items :value="tab" touchless>
                <myinfo-tab-verify @next="tab = 'modify'" />
                <v-tab-item value="modify">
                    <v-form v-model="isValid">
                        <div class="txt txt--xs text-right pb-16px pb-md-20px"><span class="red--text">* </span>필수입력 항목입니다.</div>
                        <vertical-form-table v-model="form" v-bind="{ items }">
                            <template slot="아이디">
                                {{ form?.username }}
                            </template>
                            <template slot="비밀번호 확인">
                                <v-password-confirm-field :password="form.password" placeholder="동일한 비밀번호를 재입력하세요." isModify />
                            </template>
                            <template slot="주소">
                                <v-address-field v-model="form" outlined persistent-placeholder :btnAttrs="{ large: true, color: 'primary' }" />
                            </template>
                            <!-- <template slot="추천인코드">
                                {{ form?.code_promoter?.code }}
                            </template> -->
                        </vertical-form-table>

                        <div class="btn-wrap btn-wrap--lg">
                            <v-row justify="center" class="row--sm">
                                <v-col cols="6" sm="auto">
                                    <v-btn outlined color="grey" class="v-size--xx-large w-100 min-w-sm-200px" @click="tab = 'verify'">취소</v-btn>
                                </v-col>
                                <v-col cols="6" sm="auto">
                                    <v-btn color="primary" class="v-size--xx-large w-100 min-w-sm-200px" v-bind="{ disabled }" @click="save">수정하기</v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </v-form>
                </v-tab-item>
            </v-tabs-items>
        </mypage-layout>
    </client-page>
</template>

<script>
import api from "@/api";
import CryptoAES from "@/plugins/crypto-aes";
import { initUser, rules } from "@/assets/variables";

import ClientPage from "@/components/client/templates/client-page.vue";
import MypageLayout from "@/components/client/templates/mypage-layout.vue";
import VAddressField from "@/components/plugins/vuetify/v-address-field.vue";
import MyinfoTabVerify from "@/components/client/mypage/myinfo/myinfo-tab-verify.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import VPasswordConfirmField from "@/components/plugins/vuetify/v-password-confirm-field.vue";

const items = [
    {
        term: "아이디",
    },
    {
        key: "password",
        term: "비밀번호",
        type: "password",
        placeholder: "비밀번호 변경 시 새로운 비밀번호를 입력하세요",
        autocomplete: "new-password",
        rules: rules.passwordModify,
    },
    {
        key: "password",
        term: "비밀번호 확인",
        placeholder: "동일한 비밀번호를 재입력하세요.",
        autocomplete: "new-password",
    },
    {
        key: "business.worker",
        term: "담당자명",
        type: "text",
        required: true,
        placeholder: "이름을 입력하세요.",
        rules: rules.name,
    },
    {
        key: "email",
        term: "담당자 이메일",
        type: "email",
        required: true,
        placeholder: "이메일을 입력하세요.",
        rules: rules.email,
    },
    {
        key: "phone",
        term: "연락처",
        type: "phone",
        required: true,
    },
    {
        key: "business.cert",
        term: "사업자등록증",
        type: "file",
        required: true,
        placeholder: "파일을 첨부하세요.",
    },
    {
        key: "name",
        term: "회사명",
        type: "text",
        required: true,
        placeholder: "회사명을 입력하세요.",
    },
    {
        key: "business.number",
        term: "사업자 번호",
        type: "text",
        required: true,
        placeholder: "사업자 번호를 입력하세요.",
    },
    {
        key: "business.type",
        term: "업태, 업종",
        type: "text",
        required: true,
        placeholder: "업태, 업종을 입력하세요.",
    },
    {
        key: "business.email",
        term: "세금계산서 발행 이메일",
        type: "email",
        required: true,
        placeholder: "이메일을 입력하세요.",
        rules: rules.email,
    },
    {
        term: "주소",
        type: "address",
        required: true,
    },
    // {
    //     term: "추천인코드",
    // },
].map((item) => ({ ...item, outlined: true }));

export default {
    components: {
        ClientPage,
        MypageLayout,
        VAddressField,
        MyinfoTabVerify,
        VerticalFormTable,
        VPasswordConfirmField,
    },
    data: () => ({
        form: initUser(),

        items,

        tab: "verify",
        isValid: false,
    }),
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
        disabled() {
            return !this.isValid;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                if (!this.accessToken) {
                    this.$router.push("/login");
                    return;
                }

                this.form = initUser((await api.v1.me.get())?.user);
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
                else alert(error.message.toString());
            }
        },

        async save() {
            try {
                let {
                    password,
                    business: { cert, ...business },
                    ...form
                } = this.form;

                if (password) form.password = CryptoAES.encrypt(password);

                if (cert instanceof File) cert = (await api.v1.users.postBusinessCert(cert))?.file;
                business._cert = cert?._id || null;
                form.business = business;

                const { user } = await api.v1.me.put(form);
                this.form = user;

                alert("수정되었습니다");
            } catch (error) {
                console.error(error);
                if (error.response) alert(error.response.data.message);
                else alert(error.message.toString());
            }
        },
    },
};
</script>
